function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMachines = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M95.63 81.665v-6.971l-6.223-5.974 1.991-1.494c1.991-1.494 3.237-3.734 3.237-6.224V45.568c0-1.992-.748-3.984-2.241-5.228L81.689 29.386a18.75 18.75 0 0 0-3.485-2.738v-7.967L37.376 7.728l-6.97 4.73-5.228-1.494V3.993H11.486L.034 20.673l5.477 7.966 4.73 23.401c.249 1.494.996 3.236 1.743 4.481l7.468 11.452-14.19 16.181v9.46h9.958v2.49h4.979v-7.469h-8.962l8.215-8.464 26.389 2.241c-.249.747-.249 1.742-.249 2.489 0 5.477 4.481 9.958 9.958 9.958s9.958-4.481 9.958-9.958-4.481-9.958-9.958-9.958c-2.49 0-4.979.996-6.722 2.49l-28.878-2.49 3.485-3.983h61.988l5.726 5.477v7.219l4.232 3.984v3.485H69.989v4.979h29.873V85.648l-4.232-3.983Zm-57.258-68.71 35.351 9.211v2.241L36.63 14.2l1.742-1.245ZM8.499 24.158l-2.241-3.485 7.966-11.701h5.975v2.988l-11.7 12.198Zm6.472 26.886-4.232-22.156 12.945-13.194 49.292 13.692c1.992.498 3.983 1.743 5.477 3.236l10.705 10.954c.498.498.747 1.245.747 1.992v15.434c0 .996-.498 1.743-1.245 2.241l-4.481 2.987H24.182l-7.966-12.447c-.498-.747-.996-1.743-1.245-2.739Zm40.33 29.127c2.738 0 4.979 2.241 4.979 4.979a4.994 4.994 0 0 1-4.979 4.979 4.993 4.993 0 0 1-4.979-4.979 4.994 4.994 0 0 1 4.979-4.979Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMachines);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/machines.2629bdd6736809e2bcd479cb82a47a77.svg";